import { ParseQuery } from './parse-query';
import { BannerItem } from './../data';

export class BannerItemQuery extends ParseQuery<BannerItem> {
  constructor(bannerId?: string) {
    super(BannerItem);
  }
}
